import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BaseComponent } from 'src/app/system-common/base/base.component';
import { AgentService } from '../services/agent.service';

@Component({
  selector: '',
  template: '',
})
export class AgentPartyEducationHandlerComponent extends BaseComponent<AgentService> implements OnChanges {
  public partyModel: any;

  constructor(agentService: AgentService) {
    super(agentService);
  }

  public onAddEducationDetail(event) {
    this.service.addEducationDetail(this.partyModel);
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
  }

  // public omit_special_char(event) {
  //   var k;
  //   k = event.charCode; //         k = event.keyCode;  (Both can be used)
  //   return (k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57);
  // }
}
